// config.service.ts
import { Injectable, inject } from '@angular/core';
import { DotCMSClientConfig } from '@dotcms/types';
import { Store, select } from '@ngrx/store';
import { Observable, ReplaySubject, filter, map, withLatestFrom } from 'rxjs';

import { getCurrentDotCmsApiConfiguration } from 'ish-core/store/core/configuration';
import { isServerConfigurationLoaded } from 'ish-core/store/core/server-config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: DotCMSClientConfig | null = null;
  private store = inject(Store);
  config$ = new ReplaySubject<DotCMSClientConfig>(1);

  loadConfig(): Observable<DotCMSClientConfig> {
    return this.store.pipe(
      select(isServerConfigurationLoaded),
      filter(isLoaded => isLoaded),
      withLatestFrom(this.store.pipe(select(getCurrentDotCmsApiConfiguration))),
      map(([, dotCmsConfig]) => ({
        dotcmsUrl: dotCmsConfig.host,
        authToken: dotCmsConfig.token,
        siteId: dotCmsConfig.hostId,
      }))
    );
  }

  setConfig(config: DotCMSClientConfig): void {
    this.config = config;
    this.config$.next(config);
  }

  getConfig(): DotCMSClientConfig {
    if (!this.config) {
      throw new Error('Configuration not loaded');
    }
    return this.config;
  }
  getConfig$(): ReplaySubject<DotCMSClientConfig> {
    return this.config$;
  }
}
